import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import LogoSrc from '@/assets/img/logo.gif'
import { useServiceWorker } from '@/hooks/useServiceWorker'
import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { login, selectIsAuthenticated } from '@/redux/reducers/auth.reducer'
import { getEnv } from '@/utils/helpers'

// Get logo URL from environment variables, fallback to default
const getLoginLogoUrl = () => {
  return getEnv('VITE_LOGIN_LOGO_URL') || LogoSrc
}

export default function LoginPage() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const from = _.get(location.state, 'from.pathname', '/') + _.get(location.state, 'from.search', '')
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const { refreshCache, isSupported, isRegistered } = useServiceWorker()
  const [hasRefreshedCache, setHasRefreshedCache] = useState(false)

  useEffect(() => {
    if (isSupported && isRegistered && !hasRefreshedCache) {
      console.log('Refreshing cache...')
      refreshCache().then(() => {
        setHasRefreshedCache(true)
      })
    }
  }, [isSupported, isRegistered, refreshCache, hasRefreshedCache])

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from)
    }
  }, [from, isAuthenticated, navigate])

  const handleSignIn = () => {
    dispatch(login({ locale: i18n.language, redirectUri: window.location.origin + from }))
  }

  return (
    <Container component="main" maxWidth="xs" sx={{ height: '100vh' }}>
      <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
        <img alt="logo" src={getLoginLogoUrl()} width="100%" />
        <Typography component="h1" variant="h5">
          {t('page.login.title')}
        </Typography>
        <Button id="login-button" onClick={handleSignIn} variant="contained">
          {t('page.login.signInButton.label')}
        </Button>
      </Stack>
    </Container>
  )
}
